/* eslint-disable react-hooks/rules-of-hooks */
import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";

// @mui material components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
// import Checkbox from "@mui/material/Checkbox";

// API
import { apiGetUniqueCustomersByNama, apiGetCustomersFallback } from "api/customers-paginated";

export default function dataPelanggan({
  onRowSelect,
  selectedRow,
  currentPage,
  itemsPerPage,
  search,
  refreshTrigger,
}) {
  const [pelangganData, setPelangganData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPelanggan = async () => {
      try {
        setLoading(true);
        // Prepare search params for unique nama endpoint
        const searchParams = {};
        if (search && search.nama && search.nama.trim()) searchParams.nama = search.nama.trim();
        if (search && search.no_kp && search.no_kp.trim()) searchParams.no_kp = search.no_kp.trim();
        if (search && search.nama_syarikat && search.nama_syarikat.trim())
          searchParams.nama_syarikat = search.nama_syarikat.trim();
        // Fetch unique customers by nama and other fields
        const response = await apiGetUniqueCustomersByNama(currentPage, itemsPerPage, searchParams);
        if (response && response.data) {
          setPelangganData(response.data);
          setTotalPages(response.pagination.totalPages);
          setTotalItems(response.pagination.totalItems);
        } else {
          setPelangganData([]);
          setTotalPages(1);
          setTotalItems(0);
        }
      } catch (error) {
        setPelangganData([]);
        setTotalPages(1);
        setTotalItems(0);
      } finally {
        setLoading(false);
      }
    };
    fetchPelanggan();
  }, [currentPage, itemsPerPage, refreshTrigger]);

  // Function to remove duplicates based on nama field
  const removeDuplicatesByName = (data) => {
    if (!Array.isArray(data)) return [];
    const seenNames = new Set();
    const uniqueData = [];
    data.forEach((item) => {
      const nama = item.nama ? item.nama.trim().toLowerCase() : "";
      if (nama && !seenNames.has(nama)) {
        seenNames.add(nama);
        uniqueData.push(item);
      } else if (!nama) {
        // Include items without names but with a unique identifier
        uniqueData.push(item);
      }
    });
    return uniqueData;
  };

  const Nama = ({ nama, idNama }) => {
    const handleClick = () => {
      if (!idNama) {
        alert(
          `Pelanggan "${nama}" tidak mempunyai ID yang sah. Tidak dapat membuka profil.`
        );
        return;
      }
      navigate(`/profile/customer/${idNama}`);
    };

    return (
      <MDBox display="flex" alignItems="center" lineHeight={1}>
        <MDTypography
          variant="caption"
          fontWeight="medium"
          ml={0}
          lineHeight={1}
          sx={{
            cursor: "pointer",
            color: "info.main",
            "&:hover": {
              color: "info.dark",
              textDecoration: "underline",
            },
          }}
          onClick={handleClick}
        >
          {nama}
        </MDTypography>
      </MDBox>
    );
  };

  // Prop types for internal component to satisfy ESLint
  Nama.propTypes = {
    nama: PropTypes.string,
    idNama: PropTypes.number,
  };

  Nama.defaultProps = {
    nama: "",
    idNama: null,
  };

  const generateRows = () => {
    if (loading) {
      return [
        {
          nama: <Nama nama="Loading..." nokp="" />,
          nokp: (
            <MDTypography variant="caption" color="text" fontWeight="medium">
              Loading...
            </MDTypography>
          ),
          notel: (
            <MDTypography variant="caption" color="text" fontWeight="medium">
              Loading...
            </MDTypography>
          ),
          namaSyarikat: (
            <MDTypography variant="caption" color="text" fontWeight="medium">
              Loading...
            </MDTypography>
          ),
        },
      ];
    }

    return pelangganData.map((pelanggan) => {
      return {
        nama: (
          <Nama
            nama={pelanggan.nama || "Unknown"}
            idNama={pelanggan.id}
          />
        ),
        nokp: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            {pelanggan.nokp || pelanggan.no_kp || "-"}
          </MDTypography>
        ),
        notel: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            {pelanggan.notel || pelanggan.no_tel || "-"}
          </MDTypography>
        ),
        namaSyarikat: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            {pelanggan.namaSyarikat || pelanggan.nama_syarikat || "-"}
          </MDTypography>
        ),
        statusAkaun: (
          <MDTypography
            variant="caption"
            fontWeight="medium"
            align="center"
            style={{
              display: "block",
              textAlign: "center",
              color:
                (pelanggan.statusAkaun || pelanggan.status_akaun || pelanggan.status) === "Aktif"
                  ? "green"
                  : (pelanggan.statusAkaun || pelanggan.status_akaun || pelanggan.status) ===
                    "Tidak Aktif"
                  ? "red"
                  : undefined,
            }}
          >
            {pelanggan.statusAkaun || pelanggan.status_akaun || pelanggan.status || "-"}
          </MDTypography>
        ),
      };
    });
  };

  return {
    columns: [
      { Header: "nama", accessor: "nama", width: "30%", align: "left", headerAlign: "center" },
      { Header: "no kp", accessor: "nokp", width: "20%", align: "left", headerAlign: "center" },
      { Header: "no tel", accessor: "notel", width: "20%", align: "left", headerAlign: "center" },
      { Header: "nama syarikat", accessor: "namaSyarikat", width: "15%", align: "left", headerAlign: "center" },
      { Header: "status akaun", accessor: "statusAkaun", width: "10%", align: "center", headerAlign: "center" },
    ],

    rows: generateRows(),
    pagination: {
      totalPages,
      totalItems,
      currentPage,
      actualItemsOnPage: pelangganData.length, // Add actual items displayed on current page
    },
    loading, // Return loading state
  };
}
